"use client";

import * as React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  quote: "My son's confidence and grades have improved dramatically thanks to Education Family Tutors. Highly recommended!",
  author: "Jane D.",
  role: "Parent",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503393/img/testimonial_jane_parent.png"
}, {
  id: 2,
  quote: "The coaching sessions helped me stay focused and motivated during my GCSEs. I feel more prepared than ever.",
  author: "Michael S.",
  role: "Student",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503393/img/testimonial_michael_student.png"
}, {
  id: 3,
  quote: "Professional, friendly tutors who really care about student success. My daughter loves the sessions!",
  author: "Sarah P.",
  role: "Parent",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503393/img/testimonial_sarah_parent.png"
}];
export default function Testimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15
  });
  const [isHovered, setIsHovered] = React.useState(false);
  return;
}